import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=5840ca30&scoped=true"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840ca30",
  null
  
)

export default component.exports